<template>
  <v-dialog v-model="dialogComputed" scrollable persistent>
    <v-card v-if="dialogComputed">
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0152') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="onClickClose" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text class="py-0">
        <v-container fluid>
          <v-card flat>
            <v-row>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0137')" :value="inspIndexNo" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0134')" :value="manufacturerCompanyName" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0048')" :value="inspCompanyName" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef v-if="acceptDatetime != ''" :label="$t('ELE0055')" :value="acceptDatetime" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0049')" :value="lotNo" />
              </v-col>
              <v-col cols="2">
                <TextFieldRef :label="$t('ELE0153')" :value="lotDate" />
              </v-col>
              <v-col cols="2">
                <TextFieldRef :label="$t('ELE0031')" :value="partCd" />
              </v-col>
            </v-row>
            <v-row class="mb-1">
              <v-col class="pt-0 d-flex flex-row justify-end">
                <Btn class="mx-2" :label="$t('ELE0158')" @click="onClickApp" :disabled="!canApp" />
                <Btn class="mx-2" :label="$t('ELE0159')" @click="onClickDim" :disabled="!canDim" />
                <Btn class="mx-2" :label="$t('ELE0212')" @click="onClickDimMultiple" :disabled="!canDim" />
                <Btn class="mx-2" :label="$t('ELE0393')" @click="onClickPrint" :disabled="items.length == 0" />
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined>
            <v-card-title class="py-1">
              {{ $t('ELE0023') }}
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="onClickInquiry(item)" />
                </template>
                <template v-slot:[`item.inspResultCd`]="{ item }">
                  <td
                    class="v-data-table__divider"
                    :style="{ 'background-color': getColorInspResult(item.inspResultCd) }"
                  >
                    {{ showInspResultName('InspResultCd.', item.inspResultCd, item.isOutCl) }}
                  </td>
                </template>
                <template v-slot:item.appDim="{ item }">
                  {{ $t('InspClassCd.' + item.appDim) }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-dialog v-if="appInspDialog" v-model="appInspDialog" scrollable persistent>
        <v-card>
          <v-card-title class="primary white--text py-2">
            {{ $t('ELE0211') }}
            <v-spacer />
            <Btn icon="mdi-close" @click="appInspDialog = false" depressed iconProp color="white" />
          </v-card-title>
          <v-card-text class="px-0">
            <InputAppInspForm
              :inspIndexNo="selectedItem.inspIndexNo"
              :cav.sync="selectedItem.cav"
              :numOfInsp.sync="selectedItem.numOfInsp"
              @reset="research"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-if="dimInspDialog" v-model="dimInspDialog" scrollable persistent>
        <v-card>
          <v-card-title class="primary white--text py-2">
            {{ $t('ELE0229') }}
            <v-spacer />
            <Btn
              icon="mdi-close"
              @click="
                dimInspDialog = false
                search()
              "
              depressed
              iconProp
              color="white"
            />
          </v-card-title>
          <v-card-text class="px-0">
            <InputDimInspForm
              :inspIndexNo="selectedItem.inspIndexNo"
              :cav.sync="selectedItem.cav"
              :numOfInsp.sync="selectedItem.numOfInsp"
              @reset="research"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-if="dimMultipleDialog" v-model="dimMultipleDialog" scrollable persistent>
        <v-card>
          <v-card-title class="primary white--text py-2">
            {{ $t('ELE0187') }}
            <v-spacer />
            <Btn icon="mdi-close" @click="research" depressed iconProp color="white" />
          </v-card-title>
          <v-card-text>
            <ImpInspDataForm
              :inspIndexNo="inspIndexNo"
              :inspStartDatetime="selectedMultiCavDim.inspStartDatetime"
              :lotNo="inspIndex.lotNo"
              :partCd="inspIndex.partCd"
              :partName="inspIndex.m_part.partName"
              :inspCat2="inspIndex.inspCat2"
              :inspTimingCd="inspIndex.inspTimingCd"
              :versionNo="selectedMultiCavDim.versionNo"
              @reset="research"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import { InspClassCd, InspResultCd, InspStatusCd, OqcIqcCd } from '@/enum.js'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import CheckUtil from '@/mixin/check-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import InputAppInspForm from '@/components/organisms/terminal/form/InputAppInspForm'
import InputDimInspForm from '@/components/organisms/terminal/form/InputDimInspForm'
import ImpInspDataForm from '@/components/organisms/terminal/form/ImpInspDataForm'

export default {
  name: 'SearchInspLotSubDialog',

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils, CheckUtil],

  components: {
    Btn,
    BtnLink,
    TextFieldRef,
    IconInquiry,
    InputAppInspForm,
    InputDimInspForm,
    ImpInspDataForm,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    inspIndexNo: {
      type: String,
      default: '',
      required: true,
    },
    manufacturerCompanyName: {
      type: String,
      default: '',
      required: true,
    },
    inspCompanyName: {
      type: String,
      default: '',
      required: true,
    },
    acceptDatetime: {
      type: String,
      default: '',
      required: false,
    },
    lotDate: {
      type: String,
      default: '',
      required: true,
    },
    lotNo: {
      type: String,
      default: '',
      required: true,
    },
    partCd: {
      type: String,
      default: '',
      required: true,
    },
    inspStatusCd: {
      type: String,
      default: '',
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    canApp: {
      get() {
        let result = false
        if (this.inspTimingConst && this.inspTimingConst.some((e) => e.inspClassCd == InspClassCd.APP)) {
          result = true
        }
        return result && this.isWaitingInsp && (this.canInspCompany || this.canSrcInsp)
      },
    },
    canDim: {
      get() {
        let result = false
        if (this.inspTimingConst && this.inspTimingConst.some((e) => e.inspClassCd == InspClassCd.DIM)) {
          result = true
        }
        return result && this.isWaitingInsp && this.canInspCompany
      },
    },
    isWaitingInsp: {
      get() {
        let result = false
        if (this.inspIndex) {
          if (
            this.inspIndex.inspStatusCd == InspStatusCd.WAITING_FOR ||
            this.inspIndex.inspStatusCd == InspStatusCd.IN_PROGRESS
          ) {
            result = true
          }
        }
        return result
      },
    },
    canInspCompany: {
      get() {
        let result = false
        if (this.inspIndex) {
          result = this.isInspectableCompany(this.inspIndex.inspCompanyCd, this.inspIndex.m_company.companyCatCd)
        }
        return result
      },
    },
    canSrcInsp: {
      get() {
        return this.$store.getters.isEpson && !(this.manufacturerData && !this.manufacturerData.isSrcInsp)
      },
    },
  },

  data() {
    return {
      appInspDialog: false,
      dimInspDialog: false,
      dimMultipleDialog: false,
      manufacturerData: null,
      inspTimingConst: null,
      selectedItem: {
        inspIndexNo: this.inspIndexNo,
        cav: '',
        numOfInsp: 0,
      },
      selectedMultiCavDim: {
        inspStartDatetime: '',
        versionNo: 0,
      },
      inspIndex: null,
      items: [],
      headers: [
        { text: this.$t('ELE0307'), value: 'action', divider: true, sortable: false },
        { text: this.$t('ELE0181'), value: 'inspResultCd', divider: true },
        { text: this.$t('ELE0138'), value: 'inspDate', divider: true },
        { text: this.$t('ELE0437'), value: 'inspTimingDtlCd', divider: true },
        { text: this.$t('ELE0157'), value: 'cav', divider: true },
        { text: this.$t('ELE0156'), value: 'appDim', divider: true },
        { text: this.$t('ELE0098'), value: 'numOfInsp', divider: true, align: 'end' },
        { text: this.$t('ELE0154'), value: 'inspector', divider: true },
        { text: this.$t('ELE0054'), value: 'remarks' },
      ],
    }
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.search()
      }
    },
  },

  methods: {
    showInspResultName(key, value, isOutCl) {
      return this.getInspResultName(key, value, isOutCl)
    },
    getColorInspResult(inspResultCd) {
      // 検査結果に対応する色設定
      let color = ''

      if (inspResultCd == InspResultCd.OK) {
        color = '#EDEFFD'
      } else if (inspResultCd == InspResultCd.SA_OK) {
        color = '#FCF4A1'
      } else if (inspResultCd == InspResultCd.NG) {
        color = '#F8CED2'
      }

      return color
    },
    async research() {
      this.appInspDialog = false
      this.dimInspDialog = false
      this.dimMultipleDialog = false
      await this.search()
    },
    onClickClose() {
      this.dialogComputed = false
      this.inspIndex = null
      this.items = []
      this.$emit('close')
    },
    async search() {
      try {
        this.startLoading()
        if (!this.inspIndexNo) return
        await this.getInspResult()
        await this.getInspIndex()
        this.inspTimingConst = await this.getInspTimingConst()
      } finally {
        this.stopLoading()
      }
    },
    async getInspResult() {
      try {
        const params = { inspIndexNo: this.inspIndexNo }
        this.items = await API.get('/box/inspBoxes/sub', params)
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      }
    },
    async getInspIndex() {
      try {
        const inspIndex = await API.get(`/inspIndex/inspIndexes/${this.inspIndexNo}`, {
          userCompanyCd: this.$store.getters.companyCd,
        })
        this.inspIndex = inspIndex
        if (this.$store.getters.isEpson && inspIndex.inspTimingCd == OqcIqcCd.OQC) {
          this.getManufacturerData(inspIndex.manufacturerCd)
        }
      } catch (error) {
        if (error.response.status == 404) {
          this.inspIndex = null
        } else {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
        }
      }
    },
    onClickInquiry(item) {
      this.selectedItem = {
        inspIndexNo: this.inspIndexNo,
        cav: item.cav,
        numOfInsp: item.numOfInsp,
      }
      if (item.appDim === InspClassCd.APP) {
        this.appInspDialog = true
      } else {
        this.dimInspDialog = true
      }
    },
    onClickApp() {
      this.selectedItem = {
        inspIndexNo: this.inspIndexNo,
        cav: '',
        numOfInsp: null,
      }
      this.appInspDialog = true
    },
    onClickDim() {
      this.selectedItem = {
        inspIndexNo: this.inspIndexNo,
        cav: '',
        numOfInsp: null,
      }
      this.dimInspDialog = true
    },
    onClickDimMultiple() {
      this.selectedMultiCavDim = {
        inspStartDatetime: this.inspIndex.inspStartDatetime,
        versionNo: this.inspIndex.versionNo,
      }
      this.dimMultipleDialog = true
    },
    onClickPrint() {
      const resolvedRoute = this.$router.resolve({
        name: 'R06',
        query: {
          inspIndexNo: this.inspIndexNo,
        },
      })
      window.open(resolvedRoute.href, '_blank')
    },
    async getInspTimingConst() {
      let result = []
      try {
        let params = {
          companyCatCd: this.$store.getters.companyCatCd,
          inspTimingCd: this.inspIndex.inspTimingCd,
          inspCat2: this.inspIndex.inspCat2,
        }
        result = await API.get('/master/inspTimingConstraints', params)
      } catch (error) {
        result = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      }
      return result
    },
    async getManufacturerData(manufacturerCd) {
      try {
        this.manufacturerData = await API.get(`/master/companies/${manufacturerCd}`)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      }
    },
  },
  mounted() {
    this.search()
  },
}
</script>
